import { InvoiceStatus } from '@/enums/invoice';

const getInvoiceStatusColor = (status: InvoiceStatus): string => {
  switch (status) {
    case InvoiceStatus.PENDING:
      return '#fadb14';
    case InvoiceStatus.PC:
      return '#faad14';
    case InvoiceStatus.OK:
      return '#52c41a';
    default:
      return '#fadb14';
  }
};

const getInvoiceStatus = (status: InvoiceStatus): string => {
  switch (status) {
    case InvoiceStatus.OK:
      return 'ส่งสำเร็จ';
    case InvoiceStatus.PC:
      return 'รอการตรวจสอบ';
    default:
      return 'ยังไม่ได้ส่ง';
  }
};

const getInvoiceStatusOptions = () => {
  return [
    { label: 'ทั้งหมด', value: '' },
    { label: 'ยังไม่ได้ส่ง', value: 'PENDING' },
    { label: 'รอการตรวจสอบ', value: InvoiceStatus.PC },
    { label: 'ส่งสำเร็จ', value: InvoiceStatus.OK },
  ];
};

const getInvoiceTypeOptions = () => {
  return [
    { label: 'ทั้งหมด', value: '' },
    { label: 'ใบกำกับภาษี', value: 'INV' },
    { label: 'ใบลดหนี้', value: 'CN' },
    { label: 'ใบเพิ่มหนี้', value: 'DN' },
  ];
};

export {
  getInvoiceStatusColor,
  getInvoiceStatus,
  getInvoiceStatusOptions,
  getInvoiceTypeOptions,
};
